import { render } from "./index.vue?vue&type=template&id=51daf912&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=51daf912&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=51daf912&lang=scss"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51daf912"]])

export default __exports__